var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.list && _vm.list.length > 0
  var l0 =
    g0 && _vm.list[_vm.i].type === 0
      ? _vm.__map(_vm.list[_vm.i].options, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = !(_vm.success && _vm.problemIndex === index)
            ? !String(_vm.problemIndex) || _vm.problemIndex !== index
            : null
          var m1 = !(_vm.success && _vm.problemIndex === index)
            ? !String(_vm.problemIndex) || _vm.problemIndex !== index
            : null
          return {
            $orig: $orig,
            m0: m0,
            m1: m1,
          }
        })
      : null
  var l1 =
    g0 && !(_vm.list[_vm.i].type === 0) && _vm.list[_vm.i].type === 1
      ? _vm.__map(_vm.list[_vm.i].options, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m2 = !(_vm.success && _vm.problemIndex === index)
            ? !String(_vm.problemIndex) || _vm.problemIndex !== index
            : null
          var m3 = !(_vm.success && _vm.problemIndex === index)
            ? !String(_vm.problemIndex) || _vm.problemIndex !== index
            : null
          return {
            $orig: $orig,
            m2: m2,
            m3: m3,
          }
        })
      : null
  var l2 =
    g0 &&
    !(_vm.list[_vm.i].type === 0) &&
    !(_vm.list[_vm.i].type === 1) &&
    _vm.list[_vm.i].type === 2
      ? _vm.__map(_vm.list[_vm.i].options, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 =
            _vm.success && _vm.multiple.toString().indexOf(item.code) !== -1
          var g2 = !g1
            ? !_vm.multiple || _vm.multiple.toString().indexOf(item.code) === -1
            : null
          var g3 =
            !g1 && !g2 ? _vm.multiple.toString().indexOf(item.code) : null
          var g4 =
            _vm.success && _vm.multiple.toString().indexOf(item.code) !== -1
          var g5 = !g4
            ? !_vm.multiple || _vm.multiple.toString().indexOf(item.code) === -1
            : null
          var g6 =
            !g4 && !g5 ? _vm.multiple.toString().indexOf(item.code) : null
          return {
            $orig: $orig,
            g1: g1,
            g2: g2,
            g3: g3,
            g4: g4,
            g5: g5,
            g6: g6,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        l1: l1,
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }